import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/network_logo_minicity.png';
const _withScopeId = n => (_pushScopeId("data-v-85005310"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "box" };
const _hoisted_2 = { class: "media commentWrapper" };
const _hoisted_3 = { class: "media-content" };
const _hoisted_4 = { class: "content" };
const _hoisted_5 = { class: "level is-mobile" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "networkLogo mr-2",
    src: _imports_0
}, null, -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "tag is-info is-light is-rounded has-text-weight-bold ml-1" }, "Automated Message", -1));
const _hoisted_9 = { class: "level-right" };
const _hoisted_10 = { class: "commentMessage mt-2" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paperclip mr-3" }, null, -1));
const _hoisted_14 = { class: "listFilename" };
import { CONFIG } from "@/core/config";
import { formatDateTime } from "@/core/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CommentWidget',
    props: {
        comment: {}
    },
    emits: ["viewAttachment"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            var _a;
            const _component_UserBadge = _resolveComponent("UserBadge");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("article", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, [
                                _createElementVNode("nav", _hoisted_5, [
                                    ((_a = _ctx.comment.author) === null || _a === void 0 ? void 0 : _a.id)
                                        ? (_openBlock(), _createBlock(_component_UserBadge, {
                                            key: 0,
                                            user: _ctx.comment.author,
                                            class: "level-left"
                                        }, null, 8, ["user"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _hoisted_7,
                                            _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).networkName), 1),
                                            _hoisted_8
                                        ])),
                                    _createElementVNode("small", _hoisted_9, [
                                        _createElementVNode("strong", null, _toDisplayString(_unref(formatDateTime)(_ctx.comment.createdAt)), 1)
                                    ])
                                ]),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.comment.message), 1),
                                (_ctx.comment.attachments.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.attachments, (attachment) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: attachment.id,
                                                class: "tag is-light is-rounded is-medium has-text-weight-bold mr-3 mt-1 mb-1"
                                            }, [
                                                _createElementVNode("a", {
                                                    onClick: ($event) => (_ctx.$emit('viewAttachment', attachment))
                                                }, [
                                                    _hoisted_13,
                                                    _createElementVNode("span", _hoisted_14, _toDisplayString(attachment.filename), 1)
                                                ], 8, _hoisted_12)
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
